import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Paper, Typography } from '@mui/material'
import React from 'react'
import { Trans } from 'react-i18next'

const RetrofitExplanation: React.FC = () => {
  const { t } = useCustomTranslation()

  return (
    <Paper sx={{ p: 4 }}>
      <Box
        sx={theme => ({
          px: 4,
          py: 2,
          backgroundColor: theme.palette.grey.grey07,
          borderRadius: 2,
          border: `1px solid ${theme.palette.grey.grey06}`,
        })}
      >
        <Typography variant="h3" sx={{ mb: 2 }}>
          {t('retrofit-check.explanation.title')}
        </Typography>
        <Typography variant="body2">
          <Trans
            i18nKey="retrofit-check.explanation.text"
            components={{
              br: <br />,
            }}
          />
        </Typography>
      </Box>
    </Paper>
  )
}

export default RetrofitExplanation
